module.exports = __webpack_public_path__ + "static/media/cart.101d9c57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/svg/cart.svg
// module id = 1034
// module chunks = 0